// @flow
import { createAction } from 'redux-actions';

export const requestAppConfig = createAction(
  'APP_CONFIG_REQUEST',
  (token: string) => token
);

export const receiveAppConfig = createAction(
  'APP_CONFIG_RESPONSE',
  (payload: GetAppConfigResponseBody) => payload
);

export const signalAppReady = createAction('APP_READY');
export const signalAppNotReady = createAction('APP_NOT_READY');



// WEBPACK FOOTER //
// ./src/ducks/appConfigActions.js